
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post6() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Dúvida saúde - geral - Cuidando do colesterol alto</title>
        <meta 
          name="description" 
          content="Tenho colesterol alto faz alguns anos, e quando fui diagnosticado pela primeira vez foi um pouco de choque, mas aprendi a lidar com doença e hoje meu colesterol está em níveis normais devido às mudanças que fiz de estilo de vida.

No fim, tenho certeza que o diagnóstico veio para o bem, pelo seguinte motivo: nos meus estudos aprendi que cerca de 85% das pessoas com mais de 50 anos (como é meu caso agora) tem algum bloqueio significativo em suas artérias, porém sem nenhum sintoma. Em dois terços dos casos (30% das vezes) o primeiro sintoma é um ataque do coração. Eu poderia estar nessa estatística, mas não estou, porque fui diagnosticado antes e mudei meu estilo de vida!

Duas dicas que acho que são importantes para quem descobriu que tem essa doença ou que está preocupado com seu colesterol:

1 - Saiba a diferença entre colesterol HDL (colesterol bom) e LDL (colesterol ruim), e como fazer para aumentar o colesterol bom e diminuir o ruim,.

2 - Tem 3 coisas que temos controle, e que afetam nosso colesterol e nossa saúde: nosso peso, o que comemos e nossa prática de exercícios físicos. Essas coisas estão no nosso controle e são nossa responsabilidade.

Esses pontos foram os que fizeram a diferença na minha saúde, e talvez possam fazer também na sua!
"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            L. Carrol &#183; 23/07/2024
          </p>
        </div>
        <p className="heading4 bottom-margin-s">Cuidando do colesterol alto</p>


        <p className="body content bottom-padding-s">
            Tenho colesterol alto faz alguns anos, e quando fui diagnosticado pela primeira vez foi um pouco de choque, mas aprendi a lidar com doença e hoje meu colesterol está em níveis normais devido às mudanças que fiz de estilo de vida.<br/><br/>No fim, tenho certeza que o diagnóstico veio para o bem, pelo seguinte motivo: nos meus estudos aprendi que cerca de 85% das pessoas com mais de 50 anos (como é meu caso agora) tem algum bloqueio significativo em suas artérias, porém sem nenhum sintoma. Em dois terços dos casos (30% das vezes) o primeiro sintoma é um ataque do coração. Eu poderia estar nessa estatística, mas não estou, porque fui diagnosticado antes e mudei meu estilo de vida!<br/><br/>Duas dicas que acho que são importantes para quem descobriu que tem essa doença ou que está preocupado com seu colesterol:<br/><br/>1 - Saiba a diferença entre colesterol HDL (colesterol bom) e LDL (colesterol ruim), e como fazer para aumentar o colesterol bom e diminuir o ruim,.<br/><br/>2 - Tem 3 coisas que temos controle, e que afetam nosso colesterol e nossa saúde: nosso peso, o que comemos e nossa prática de exercícios físicos. Essas coisas estão no nosso controle e são nossa responsabilidade.<br/><br/>Esses pontos foram os que fizeram a diferença na minha saúde, e talvez possam fazer também na sua!<br/>
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/6')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  2 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              Nenhum comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/6')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Carla Esteves &#183; 08/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/52-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa noite pessoal. <br/>Alguém que está fazendo quimioterapia sente os pés dormentes e as pontas dos dedos das mãos? <br/>Meus pés estão muito dormentes, e está aumentando. Estou na quinta sessão de quimio
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/52')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Gabrielli Machado &#183; 18/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/124-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Bom dia!<br/>Meu exame de Histoquímico tem o seguinte resultado:<br/>Hers 2 negativo escore 0<br/>Mas alguém teve esse resultado e sabe me falar o significado?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/124')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Leonardo Silveira &#183; 18/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/2-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Os benefícios para saúde de ter um Border Collie  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Há anos atrás, quando estava na faculdade, eu costumava correr na rua em algum parque 2 ou 3 vezes na semana, por cerca de 30 minutos. Com o tempo, e conforme fui ficando mais ocupado, acabei deixando esse bom hábito de lado. E uma vez que o hábito de exercício físico normalmente traz consigo outros hábitos, como de uma alimentação mais saudável e menos bebida alcoólica, esses também foram se deteriorando com o tempo. Consequentemente, ao longo dos anos sutilmente resultados disso foram surgindo, como aumento de peso e menor disposição.<br/><br/>Dois anos atrás, porém, decidi junto com minha esposa adotar um cachorro, e escolhemos uma Border Collie. A nova integrante da família, conforme nós esperávamos, nos forçou a uma série de mudanças na rotina. Eu fiquei responsável pelos passeios duas vezes por dia: às 6 da manhã, antes do trabalho, e no final da tarde. Isso me forçou diretamente e sem rodeios a iniciar uma atividade física disfarçada, que foram as caminhadas com nossa cachorra, que foram aumentando de duração e intensidade conforme ele crescia.<br/><br/>A raça Border Collie é conhecida por ser a raça mais inteligente, e também de alta energia. E sem dúvida existe alguma verdade nessa afirmação. As caminhadas deixaram de ser o bastante para a nossa cachorra, e para conseguir gastar sua energia e mantê-la saudável treinamos ela para jogar frisbee: pegar o disco no ar após jogarmos e traze-lo novamente para nós, em um ciclo aparentemente infinito de arremessos. Ela aprendeu rapidamente o esporte e se tornou um dos melhores cachorros que já vimos pegando o disco no ar em saltos acrobáticas.<br/> <br/>Porém, as caminhadas intensas duas vezes por dia com ela me fez lembrar de como eu me sentia bem após uma corrida intensa na época da faculdade, e como estava disposto no dia seguinte para o estudo e trabalho. Com isso, comecei aos poucos a correr junto de minha cachorra na rua. Essa corrida foi aumentando, primeiro somente a tarde alguns dias, depois mais alguns dias de manhã, e por fim, hoje corro com ela todos os dias de manhã e a tarde.<br/><br/>Isso mantém minha cachorra feliz e nós dois saudáveis, além de me manter disposto e com mais energia do que me sentia em anos. E hoje nem penso em não fazer isso, simplesmente porque sei como me sinto e vejo como ela fica feliz na horário dos nossos passeios. Esse são alguns, dos muitos benefícios de ter um Border Collie (ou qualquer outro cachorro) como companheiro.<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/2')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Camila da Silveira &#183; 21/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/142-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Hoje fui no meu endocrinologista e ele mudou meu medicamento que já tomava faz tempo cloridrato de pioglitasona 15mg por forxiga 10mg. Reparei que a diferença de preço é grande. Esse Forxiga é muito melhor?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/142')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Marcela Prattes &#183; 15/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/104-colesterol" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Alguma dica de algo natural para baixar triglicerídeos?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/104')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
